var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessReplace({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5293 2C8.9093 2 10.1593 2.56 11.0693 3.46L8.5293 6H14.5293V0L12.4793 2.05C11.2093 0.78 9.4593 0 7.5293 0C3.9993 0 1.0993 2.61 0.609297 6H2.6293C3.0893 3.72 5.1093 2 7.5293 2ZM13.1693 11.14C13.8293 10.24 14.2893 9.17 14.4493 8H12.4293C11.9693 10.28 9.9493 12 7.5293 12C6.1493 12 4.8993 11.44 3.9893 10.54L6.5293 8H0.529297V14L2.5793 11.95C3.8493 13.22 5.5993 14 7.5293 14C9.0793 14 10.7378 13.0964 11.8978 12.2464L11.2823 12.8619L12.7723 11.3719L13.1693 11.14Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessReplace);
export default __webpack_public_path__ + "static/media/process-replace.68a7ae0d950140eb3e19c2848e2eb54e.svg";
export { ForwardRef as ReactComponent };